function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import { CopyToClipboard } from "react-copy-to-clipboard";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import { useNotificationContext } from "@limitless/common/hooks";
const useStyles = makeStyles(theme => ({
  textButton: {
    borderRadius: 0,
    padding: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    minWidth: "unset",
    textAlign: "left",
    display: "grid"
  },
  label: {
    "line-clamp": 1,
    display: "box",
    "box-orient": "vertical",
    overflow: "hidden"
  }
}));
const TextButton = ({
  children,
  copyToClipboard,
  copySuccess,
  clamp = true,
  ...rest
}) => {
  const classes = useStyles();
  const {
    addSuccessNotification
  } = useNotificationContext();
  const button = React.useMemo(() => {
    return /*#__PURE__*/React.createElement(Button, _extends({}, rest, {
      color: "secondary",
      classes: {
        text: classes.textButton,
        label: clamp ? classes.label : ""
      }
    }), children);
  }, [children, rest]);
  if (copyToClipboard) {
    return /*#__PURE__*/React.createElement(CopyToClipboard, {
      text: children,
      onCopy: () => {
        addSuccessNotification(copySuccess);
      }
    }, button);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, button);
};
export default TextButton;
TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  copyToClipboard: PropTypes.bool,
  copySuccess: PropTypes.string,
  clamp: PropTypes.bool
};
TextButton.defaultProps = {
  copyToClipboard: false
};